module.exports = __webpack_public_path__ + "img/article_home.78d7c90a.svg";